import { AccountTreeOutlined, Add, HighlightOff, SaveOutlined, ScheduleOutlined, Sync, UploadOutlined } from '@mui/icons-material'
import { Alert, Box, Button, Menu, MenuItem, Stack, Tab, Tabs, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ThirdPartyConnectionDetailsService from '../../../../modules/third-party-connection/shared-services/third-party-connection-details/third-party-connection.service';
import { ICoverageSummary, IThirdPartyConnectionDetails, IThirdPartyConnectionDetailsCompany } from '../../../../modules/third-party-connection/shared-services/third-party-connection-details/third-party-connection-details.model';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { SelectTenantDialog } from '../../../dialogs/select-tenant-dialog';
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods';
import { ICommitAllImportLinesResult, IDiscardedImportAndIntegrationLines, IFormattedImportLine } from '../../../../modules/third-party-connection/shared-services/third-party-connection-import-line/third-party-connection-import-line.model';
import ThirdPartyConnectionImportLineService from '../../../../modules/third-party-connection/shared-services/third-party-connection-import-line/third-party-connection-import-line.service';
import gaiaTheme from '../../../../root-components/theme';
import { EmissionsFinancialOutstandingTable } from '../../../presentation-components/emissons-components/financial/emissions-financial-outstanding-table';
import { EmissionsFinancialDiscardedTable } from '../../../presentation-components/emissons-components/financial/emissions-financial-discarded-table';
import { Emissions } from '../../../presentation-components/emissons-components/overview/emissions';
import { LoadingButton } from '@mui/lab';
import { CsvUploadSpendBased } from '../../../presentation-components/settings-components/data-import/csv-upload-spend-based';
import { IContactSupplierDetails } from '../../../../shared/services/contact-supplier/contact-supplier.model';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { a11yProps, deleteQueryParamFromUrl } from '../../../../shared/utils/misc-shared-utils';
import { CustomTabPanel } from '../../../presentation-components/display-elements-components/custom-tab-panel';
import ContactSupplierService from '../../../../shared/services/contact-supplier/contact-supplier.service';
import SpendBasedConversionService from '../../../../shared/services/spend-based-conversion/spend-based-conversion.service';
import { ISpendBasedConversion } from '../../../../shared/services/spend-based-conversion/spend-based-conversion.model';
import { LoadingPage } from '../../loading-page';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageTitle } from '../../../presentation-components/display-elements-components/page-title';
import { IEditFileUploadLineSpendBased, IFileUploadLineSpendBased, IPostFileUploadLineSpendBased } from '../../../../shared/services/file-upload-all-lines/file-upload-all-lines.model';
import FileUploadAllLineService from '../../../../shared/services/file-upload-all-lines/file-upload-all-lines.service';
import { ClosedReportPeriodMessage } from '../../../presentation-components/miscellaneous-components/closed-report-period-message';
import { StartNewReportPeriodDialog } from '../../../dialogs/settings/report-period/start-new-report-period-dialog';
import SubsidiaryService from '../../../../shared/services/subsidiary/subsidiary.service';
import { useHasOpenReportPeriod } from '../../../../hooks/use-has-open-report-period';
import { ISubsidiary } from '../../../../shared/services/subsidiary/subsidiary.model';
import GroupService from '../../../../shared/services/group/group.service';
import { IGroup } from '../../../../shared/services/group/group.model';
import { useIsReportPeriodLocked } from '../../../../hooks/use-is-report-period-locked';
import { AddManualSpendBasedDialog } from '../../../dialogs/emissions/add-manual-spend-based-dialog';
import { DEFRA_SPEND_CONVERSION_SOURCE_ID } from '../../../../shared/constants/conversion-sources';
import { buildCoverageMessage } from '../../../../shared/utils/coverage-summary-utils';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';
import ScheduleService from '../../../../shared/services/schedule/schedule.service';
import { ISchedule } from '../../../../shared/services/schedule/schedule.model';
import { ScheduleSyncDialog } from '../../../dialogs/settings/schedule-sync-dialog';
import { AccountingSyncProvider } from '../../../../shared/services/schedule/schedule.model';
import { hasActiveAccountingSchedule, ILedgerSyncRequest, SCHEDULES_LINK } from '../../../../shared/utils/ledger-sync-utils';

export const EmissionsFinancialPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams()
  //Services
  const thirdPartyConnectionDetailsService = new ThirdPartyConnectionDetailsService();
  const scheduleService = new ScheduleService();
  const thirdPartyConnectionImportLineService = new ThirdPartyConnectionImportLineService();
  const fileUploadAllLineService = new FileUploadAllLineService()
  const contactSupplierService = ContactSupplierService.getInstance();
  const spendBasedConversionService = new SpendBasedConversionService()
  const subsidiaryService = SubsidiaryService.getInstance()
  const groupService = new GroupService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext);
  const reportPeriodContext = useContext(ReportPeriodContext);
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  const screenLabelsContext = useContext(ScreenLabelsContext)
  //State
  const [resultYears, setResultYears] = useState<number[]>()
  const [groups, setGroups] = useState<IGroup[]>()
  const [activeConnections, setActiveConnections] = useState<IThirdPartyConnectionDetails[]>()
  const [companies, setCompanies] = useState<IThirdPartyConnectionDetailsCompany[]>()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const openDropdown = Boolean(anchorEl)
  // Set up accounting connection: offered when ledgers are available but none is connected yet.
  const [setUpAnchorEl, setSetUpAnchorEl] = React.useState<null | HTMLElement>(null)
  // Schedule sync: the organisation's schedules decide whether the button offers to schedule a
  // ledger or to manage the schedule that already syncs one.
  const [schedules, setSchedules] = useState<ISchedule[]>()
  const [scheduleAnchorEl, setScheduleAnchorEl] = React.useState<null | HTMLElement>(null)
  const [scheduleProvider, setScheduleProvider] = useState<IThirdPartyConnectionDetails>()
  // A sync handed over by an integration page runs once, however many times effects fire.
  const startedSyncRef = useRef<ILedgerSyncRequest>()
  const [value, setValue] = React.useState(0)
  const [openDialog, setDialogOpen] = React.useState<boolean>(false);
  const [openReportPeriodDialogOpen, setOpenReportPeriodDialogOpen] = useState(false);
  const [connectionCode, setConnectionCode] = useState<string>();
  const [connectionName, setConnectionName] = useState<string>();
  const [outstandingImportLines, setOutstandingImportLines] = useState<IFormattedImportLine[]>();
  const [discardedImportLines, setDiscardedImportLines] = useState<IDiscardedImportAndIntegrationLines[]>();
  const [editUploadSpendBasedLine, setEditUploadSpendBasedLine] = useState<IFileUploadLineSpendBased>()
  const [selected, setSelected] = useState<string[]>([]);
  const [selectedPending, setSelectedPending] = useState<string[]>([]);
  const [validatedUploadLines, setValidatedUploadLines] = useState<IPostFileUploadLineSpendBased[]>();
  const [pendingUploadLines, setPendingUploadLines] = useState<IPostFileUploadLineSpendBased[]>();
  const [subsidiaries, setSubsidiaries] = useState<ISubsidiary[]>()
  const [allContactSuppliers, setAllContactSuppliers] = useState<IContactSupplierDetails[]>()
  const [allSpendBasedConversions, setAllSpendBasedConversions] = useState<ISpendBasedConversion[]>()
  const [fileUpload, setFileUpload] = useState<IFileUploadLineSpendBased[]>();
  const [fileUploadMatched, setFileUploadMatched] = useState<IFileUploadLineSpendBased[]>();
  const [selectedSupplier, setSelectedSupplier] = React.useState<string>('')
  // The integration filter on the Pending via Integrations tab: '' is every integration. The
  // options are the integrations with pending lines in the period, read with each fetch.
  const [selectedIntegration, setSelectedIntegration] = React.useState<string>('')
  const [integrationOptions, setIntegrationOptions] = useState<string[]>([])
  const [openSpendBasedDialog, setDialogSpendBasedOpen] = React.useState(false)
  const [openManualSpendBasedDialog, setManualSpendBasedDialogOpen] = React.useState(false)
  //Table State
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [inputPageMatched, setInputPageMatched] = useState(0);
  const [totalRecordsMatched, setTotalRecordsMatched] = useState(0)
  const [perPageMatched, setPerPageMatched] = useState(10)
  const [change, setChange] = useState<number>(0)
  const [orderBy, setOrderBy] = useState<string>()
  const [order, setOrder] = useState<'asc' | 'desc'>()
  const [orderByMatched, setOrderByMatched] = useState<string>()
  const [orderMatched, setOrderMatched] = useState<'asc' | 'desc'>()
  //Loading State
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  const [isDialogSubmitting, setIsDialogSubmitting] = useState<boolean>(false)
  const [isCommitSubmitting, setIsCommitSubmitting] = useState<boolean>(false)
  const [isCommitAllSubmitting, setIsCommitAllSubmitting] = useState<boolean>(false)
  const [isDiscardSubmitting, setIsDiscardSubmitting] = useState<boolean>(false)
  const [isSyncing, setIsSyncing] = useState<boolean>(false)
  // Structured coverage of the most recent manual sync, shown above the review table so
  // what the sync did and did not capture is visible beyond the snackbar.
  const [lastSyncCoverage, setLastSyncCoverage] = useState<ICoverageSummary | null>(null)
  const [isDiscardingCommitted, setIsDiscardingCommitted] = useState<boolean>(false)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));
  //Hooks 
  const hasOpenReport = useHasOpenReportPeriod([
    reportPeriodContext.allReportPeriods,
    reportPeriodContext.lastSelectedReportId
  ]);
  const isReportPeriodLocked = useIsReportPeriodLocked()
  // Bounds for the date a sync can read again from.
  const selectedReportPeriod = reportPeriodContext.allReportPeriods?.find(period => period.id === reportPeriodContext.lastSelectedReportId)
  // const filterConfig = filterSpendBasedConfig;
  const isAnyActionInProgress = isCommitSubmitting || isCommitAllSubmitting || isDiscardSubmitting || isDiscardingCommitted;
  //Use Effects
  // Keyed on the search params, not on mount: a link from elsewhere in the app (the Business
  // Central page's Review button) must switch the tab and filter without a remount.
  useEffect(() => {
    if (!searchParams.has('tabId') && !searchParams.has('integration')) return
    const tab = searchParams.get('tabId')
    if (tab) {
      setValue(parseInt(tab))
    }
    const integration = searchParams.get('integration')
    if (integration) {
      setSelectedIntegration(integration)
    }
    deleteQueryParamFromUrl(searchParams, 'tabId')
    deleteQueryParamFromUrl(searchParams, 'integration')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  useEffect(() => {
    subsidiaryService.getAll()
      .then(response => {
        setSubsidiaries(response)
      })
      .catch(err => console.log(err))
    groupService.getGroups()
      .then(response => {
        setGroups(response)
      })
      .catch(err => console.log(err))
    contactSupplierService.getActiveSuppliersLite(false)
      .then(response => {
        setAllContactSuppliers(response)
      })
      .catch(err => console.log(err))

    thirdPartyConnectionDetailsService.getAvailableConnections()
      .then(response => {
        const financialConnections = response.filter(r => r.details === 'financial')
        setActiveConnections(financialConnections)
      })
      .catch(err => console.log(err))
    if (userDetails?.roles.includes('admin')) loadSchedules()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadSchedules = () => {
    scheduleService.getAll({ perPage: 100, page: 0 })
      .then(response => setSchedules(response.rows))
      .catch(() => setSchedules([]))
  }

  // A sync started from an integration page: run it here exactly as Sync Data would, once the
  // report period is known, then drop it from the history so a refresh does not run it again.
  useEffect(() => {
    const request: ILedgerSyncRequest | undefined = location.state?.startSync
    if (!request || !reportPeriodContext.lastSelectedReportId || startedSyncRef.current === request) return
    startedSyncRef.current = request
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null })
    setConnectionCode(request.provider)
    setConnectionName(activeConnections?.find(connection => connection.code === request.provider)?.name || request.provider)
    setIsSyncing(true)
    submitDialogHandler(request.provider, request.companyId, undefined, request.syncFrom)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, reportPeriodContext.lastSelectedReportId])

  useEffect(() => {
    if (value === 0) {
      getAllThirdPartyConnectionImportLines('outstanding')
    }
    if (value === 1) {
      getUploads();
    }
    if (value === 2) {
      setIsLoading(false) // Emissions component will handle its own loading
    }
    if (value === 3) {
      getAllThirdPartyConnectionImportLines('discarded')
    }
  }, [reportPeriodContext.lastSelectedReportId, inputPage, perPage, inputPageMatched, perPageMatched, change, value, orderBy, order])

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage !== 0) {
        setInputPage(0)
      }
      setChange(change + 1)
    }
    setHasPageMounted(true)
  }, [selectedSupplier, selectedIntegration, value, reportPeriodContext.lastSelectedReportId, orderBy, orderByMatched, order, orderMatched])

  // const handleFilterChange = (filters: Record<string, any>) => {
  //   const nextFilters = filters || {};
  //   setCompletedFilters(nextFilters);
  //   // Reset completed pagination and refetch completed only
  //   setInputPage(0);
  //   setIsLoading(true);
  //   getAllThirdPartyConnectionImportLines('completed', nextFilters);
  // };


  const getUploads = () => {
    if (reportPeriodContext.lastSelectedReportId) {
      let completedRequests = 0
      fileUploadAllLineService.getUploadLinesWithPaginationByReportPeriod('spend-based', reportPeriodContext.lastSelectedReportId, 'pending', inputPage, perPage, orderBy, order)
        .then(response => {
          setFileUpload(response.rows as IFileUploadLineSpendBased[])
          setTotalRecords(response.count)
          checkLoadingStatus()
        })
        .catch(err => console.log(err))

      fileUploadAllLineService.getUploadLinesWithPaginationByReportPeriod('spend-based', reportPeriodContext.lastSelectedReportId, 'matched', inputPageMatched, perPageMatched, orderByMatched, orderMatched)
        .then(response => {
          setFileUploadMatched(response.rows as IFileUploadLineSpendBased[])
          setTotalRecordsMatched(response.count)
          checkLoadingStatus()
        })
        .catch(err => console.log(err))

      const checkLoadingStatus = () => {
        completedRequests += 1;
        if (completedRequests === 2) {
          setIsLoading(false);
        }
      };
    } else {
      setIsLoading(false)
    }
  }

  const getAllThirdPartyConnectionImportLines = (queryParam: string, filtersOverride?: Record<string, any>) => {
    if (queryParam === 'outstanding' && reportPeriodContext.lastSelectedReportId) {
      thirdPartyConnectionImportLineService.getAllImportLinesWithPagination(`?isCommitted=false&isDiscarded=false&reportPeriodId=${reportPeriodContext.lastSelectedReportId}&contactSupplierId=${selectedSupplier}&providerCode=${selectedIntegration}&includeYears=true&includeProviders=true`, inputPage, perPage, orderBy, order)
        .then(response => {
          setOutstandingImportLines(response.rows)
          setTotalRecords(response.count);
          setIntegrationOptions(response.providerCodes || [])
          const years = (response as any).years as number[] | undefined
          if (Array.isArray(years) && years.length > 0) {
            // The activity dropdown must offer the factor set each committed row would
            // resolve against: the supplier's default spend source, else the user's
            // default subsidiary's, else the platform default (mirrors the backend's
            // resolving-source ladder).
            //
            // Every source the visible lines need is loaded, not one source for the whole
            // table. Suppliers on one page can resolve against different sources, and
            // loading only the subsidiary's meant a line whose supplier overrides it had
            // its own factor missing from the options, so the dropdown rendered empty and
            // the row looked unclassified when it was not.
            const defaultSubsidiary = subsidiaries?.find(subsidiary => subsidiary.id === userDetails?.defaultSubsidiaryId)
            const fallbackSourceId = defaultSubsidiary?.defaultSpendBasedConversionSourceId
              || DEFRA_SPEND_CONVERSION_SOURCE_ID
            // Taken from the lines' OWN conversions, not from the supplier list. Each line
            // already carries the conversion it resolved to, so this cannot race: deriving
            // it from suppliers or subsidiaries depends on those lists having loaded, and
            // whichever way that race fell decided whether the dropdown worked. That is why
            // the first page looked fine and a page change blanked every row.
            //
            // The fallback source is always included so a line with no factor yet still has
            // activities to choose from.
            const sourceIds = [...new Set(
              response.rows
                .map((line: IFormattedImportLine) => line.spendBasedConversion?.conversionSourceId)
                .concat(fallbackSourceId)
                .filter(Boolean)
            )] as string[]

            Promise.all(sourceIds.map(sourceId =>
              spendBasedConversionService
                .getSpendBasedConversionsForConversionSourceIncludingResultYears(sourceId, undefined, true, true, years)
                // One unreadable source must not empty the dropdown for every other row.
                .catch(() => ({ rows: [], resultYears: [] as number[] }))))
              .then(results => {
                setAllSpendBasedConversions(results.flatMap(result => result.rows))
                setResultYears([...new Set(results.flatMap(result => result.resultYears))])
              })
              .catch(err => console.log(err))
          } else {
            setAllSpendBasedConversions([])
          }
          setIsLoading(false)
        })
        .catch(err => {
          setIsLoading(false)
          console.log(err)
        })
    } else if (queryParam === 'discarded' && reportPeriodContext.lastSelectedReportId) {
      thirdPartyConnectionImportLineService.getDiscardedSpendBasedImportAndIntegrationsWithPagination(`?reportPeriodId=${reportPeriodContext.lastSelectedOpenReportId}&contactSupplierId=${selectedSupplier}`, inputPage, perPage, orderBy, order)
        .then(response => {
          setDiscardedImportLines(response.rows)
          setTotalRecords(response.count);
          setIsLoading(false)
        })
        .catch(err => console.log(err))
    } else {
      setIsLoading(false)
    }
  }

  const changeTabHandler = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setIsLoading(true)
    setSelectedSupplier('')
    setSelectedIntegration('')
  };

  const closeDropdownHandler = () => {
    setAnchorEl(null);
  };

  // Sync Data and Schedule sync offer only the ledgers this organisation has connected; the
  // rest are what Set up accounting connection offers.
  const connectedConnections = (activeConnections || []).filter(connection => connection.connected).sort((a, b) => a.name.localeCompare(b.name))
  const availableConnections = (activeConnections || []).slice().sort((a, b) => a.name.localeCompare(b.name))
  const hasConnectedLedger = connectedConnections.length > 0
  const activeProviderCodes = connectedConnections.map(connection => connection.code)
  const hasScheduledSync = hasActiveAccountingSchedule(schedules, activeProviderCodes)

  // Schedule sync: one ledger opens its dialog straight away, several offer a choice. Once a
  // schedule already syncs a connected ledger the button leads to the schedules page instead.
  const clickScheduleHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (hasScheduledSync) {
      navigate(SCHEDULES_LINK)
      return
    }
    if (connectedConnections.length === 1) {
      setScheduleProvider(connectedConnections[0])
    }
    if (connectedConnections.length > 1) {
      setScheduleAnchorEl(event.currentTarget);
    }
  };

  const closeScheduleDialogHandler = () => {
    setScheduleProvider(undefined)
    // A schedule may have been created or joined: the button's label follows.
    loadSchedules()
  };

  const clickDropdownHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (connectedConnections.length === 1) {
      connectionHandler(connectedConnections[0].code, connectedConnections[0].name)
    }
    if (connectedConnections.length > 1) {
      setAnchorEl(event.currentTarget);
    }
  };

  const connectionHandler = (connectionCode: string, connectionName: string,) => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({
        active: true,
        title: 'Action Not Allowed',
        message: `The selected report period is locked and cannot be modified`,
        buttonCopy: 'Ok',
        hideCancelButton: true
      })
    } else {
      setConnectionCode(connectionCode)
      setConnectionName(connectionName)
      if (['xero', 'quickbooks', 'sage', 'sage200', 'businesscentral'].includes(connectionCode)) {
        if (!isSyncing) {
          setIsSyncing(true)
          thirdPartyConnectionDetailsService.getConnectedCompanies(connectionCode)
            .then(response => {
              setCompanies(response)
              if (response.length === 0) {
                handleNoCompany();
                setIsSyncing(false)
              }
              // The dialog opens for one company too: it is where a date to read again from
              // is chosen, and it preselects the only company.
              if (response.length >= 1) {
                openDialogHandler();
                closeDropdownHandler();
              }
            })
            .catch(err => {
              setIsSyncing(false)
              console.log(err)
              handleError(connectionCode);
            })
        }
      }
    }
  }

  const handleNoCompany = () => {
    userNotificationsContext.openDialog({
      active: true,
      title: 'No Available Company',
      message: `You have no companies associated with this connection. Please visit the integrations page to set up your connections.`,
      buttonCopy: 'Ok',
      hideCancelButton: true
    })
      .then(() => {
        if (connectionCode) {
          navigate(`/settings/integrations/${connectionCode}`)
        }
        else {
          navigate(`/settings/integrations`)
        }
      })
  }

  const handleError = (connectionCode: string) => {
    userNotificationsContext.openDialog({
      active: true,
      title: 'Error',
      message: `There has been an error connecting to this provider. Please visit the integrations page and try again.`,
      buttonCopy: 'Ok',
      hideCancelButton: true
    })
      .then(() => {
        navigate(`/settings/integrations/${connectionCode}`)
      })
  }

  const openDialogHandler = () => {
    setDialogOpen(true);
  };

  const closeDialogHandler = () => {
    setDialogOpen(false);
    setIsSyncing(false)
  };

  const submitDialogHandler = (connectionCode: string, companyId: string, resetForm?: () => void, syncFrom?: string | null) => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({
        active: true,
        title: 'Action Not Allowed',
        message: `The selected report period is locked and cannot be modified`,
        buttonCopy: 'Ok',
        hideCancelButton: true
      })
    } else {
      if (!isDialogSubmitting) {
        setIsDialogSubmitting(true)
        // A chosen date reads the ledger again from there and brings back documents whose
        // emissions were deleted since; without one the sync continues from the last one.
        const syncQuery = `?companyId=${companyId}${syncFrom ? `&dateFrom=${syncFrom}&restoreDeleted=true` : ''}`
        thirdPartyConnectionDetailsService.getTransactions(reportPeriodContext.lastSelectedReportId!, connectionCode, syncQuery)
          .then((response) => {
            if (resetForm) resetForm();
            getAllThirdPartyConnectionImportLines('outstanding');
            // Honest per-sync coverage: what came back, what was imported, what was set
            // aside and why, rather than silently dropping rows. The structured summary
            // also feeds the panel above the review table; the legacy skippedReason is
            // the fallback for older records.
            const coverage = response.coverageSummary || null
            if (response.code !== 1) setLastSyncCoverage(coverage)
            // Staged excluded lines (bills set aside because bill import is off) come
            // back on the record but are not review work, so they are not "imported".
            const importedCount = (response.thirdPartyConnectionImportLines || []).filter(line => !line.isDiscarded).length
            const skipped = response.skippedCount || 0
            const coverageNote = !coverage && skipped > 0 && response.skippedReason
              ? ` ${skipped} row${skipped === 1 ? '' : 's'} skipped: ${response.skippedReason}.`
              : ''
            if (response.code === 1) {
              userNotificationsContext.openSnackbar({ open: true, message: `Records already up to date` });
            } else if (importedCount === 0) {
              userNotificationsContext.openSnackbar({ open: true, message: `No new records imported.${coverageNote}` });
            } else {
              userNotificationsContext.openSnackbar({ open: true, message: `Successfully imported ${importedCount} record${importedCount === 1 ? '' : 's'}.${coverageNote}` });
            }
          })
          .catch((err) => {
            if (err?.response?.data?.code === 1) {
              userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
            } else if (err?.response?.data?.message) {
              // A refusal that says why (not connected, a Business Central setup step) is shown
              // as it is; only an unexplained failure sends the user to the integrations page.
              userNotificationsContext.openSnackbar({ open: true, message: err.response.data.message, backgroundColor: 'text.primary' });
            } else {
              handleError(connectionCode);
            }
            setIsSyncing(false);
            setIsDialogSubmitting(false)
          })
          .finally(() => {
            setIsSyncing(false);
            setIsDialogSubmitting(false)
            closeDialogHandler();
            closeDropdownHandler();
            setValue(0);
          });
      }
    }
  };

  const submitSpendBasedHandler = (lineId: string, editUploadLine: IEditFileUploadLineSpendBased) => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
    } else {
      if (!allContactSuppliers) {
        return editFileUploadLine(lineId, editUploadLine, false);
      }
      const selectedContactSupplier = allContactSuppliers.find(
        supplier => supplier.name === editUploadLine.contactName
      );
      if (!editUploadLine.spendBasedConversionName || !selectedContactSupplier || selectedContactSupplier.spendBasedConversionId !== null) {
        return editFileUploadLine(lineId, editUploadLine, false);
      }
      if (!allSpendBasedConversions) {
        return editFileUploadLine(lineId, editUploadLine, false);
      }
      const selectedSpendBasedConversion = allSpendBasedConversions.find(
        conversion => conversion.activity === editUploadLine.spendBasedConversionName
      );
      if (!selectedSpendBasedConversion) {
        return editFileUploadLine(lineId, editUploadLine, false);
      }
      userNotificationsContext
        .openDialog({
          active: true,
          title: "Confirmation",
          message: `Would you like to set ${selectedSpendBasedConversion.activity} as the default spend activity for ${selectedContactSupplier.name}?`,
          buttonCopy: "Yes",
          cancelButtonCopy: "No",
        })
        .then((response) => {
          if (response) {
            editFileUploadLine(lineId, editUploadLine, true);
          } else {
            editFileUploadLine(lineId, editUploadLine, false);
          }
        })
        .catch(err => {
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          console.log(err)
        })
    }
  }

  const editFileUploadLine = (lineId: string, editUploadLine: IEditFileUploadLineSpendBased, updateSupplier: boolean) => {
    if (!isDialogSubmitting) {
      setIsDialogSubmitting(true)
      fileUploadAllLineService.editUploadLine(editUploadLine, lineId, 'spend-based', updateSupplier)
        .then(response => {
          // The supplier's default activity changed, so the cached supplier lists are out of date.
          if (updateSupplier) contactSupplierService.clearData();
          getUploads();
          userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
          closeSpendBasedDialogHandler();
          setIsDialogSubmitting(false)
        })
        .catch(err => {
          if (err.response.data.code === 1) {
            userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
          setIsDialogSubmitting(false)
          console.log(err)
        })
    }
  }

  const editSpendBasedClickHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, uploadLine: IFileUploadLineSpendBased) => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
    } else {
      e.stopPropagation()
      setDialogSpendBasedOpen(true);
      setEditUploadSpendBasedLine(uploadLine)
    }
  }

  const saveHandler = () => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
    } else {
      if (validatedUploadLines) {
        if (!isCommitSubmitting) {
          setIsCommitSubmitting(true)
          fileUploadAllLineService.createUploadLine(validatedUploadLines, 'spend-based')
            .then(response => {
              if (inputPageMatched > 0 && fileUploadMatched && (fileUploadMatched.length === 1 || validatedUploadLines.length === fileUploadMatched.length)) {
                setInputPageMatched(inputPageMatched - 1)
              } else {
                getUploads()
              }
              setSelected([])
              setValidatedUploadLines([])
              userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
              setIsCommitSubmitting(false)
            })
            .catch(err => {
              if (err.response.data.code === 1) {
                userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
              } else {
                userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
              }
              console.log(err)
              setIsCommitSubmitting(false)
            })
        }
      }
    }
  }

  const saveAllHandler = () => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
    } else {
      if (fileUploadMatched) {
        if (!isCommitAllSubmitting) {
          setIsCommitAllSubmitting(true)
          fileUploadAllLineService.createUploadLine([], 'spend-based', `commitAll=true`)
            .then(response => {
              userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
              getUploads();
              setIsCommitAllSubmitting(false)
            })
            .catch(err => {
              if (err.response.data.code === 1) {
                userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
              } else {
                userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
              }
              console.log(err)
              setIsCommitAllSubmitting(false)
            })
        }
      }
    }
  }


  // Commit everything ready on the Pending via Integrations tab: the period, the integration and
  // the supplier filter. The server selects, so it is not limited to the page shown, and commits
  // in bounded batches, so a large period takes a few calls rather than one long one.
  const commitAllIntegrationLinesHandler = async () => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
      return
    }
    if (isCommitAllSubmitting || !reportPeriodContext.lastSelectedReportId) return
    const request = {
      reportPeriodId: reportPeriodContext.lastSelectedReportId,
      providerCodes: selectedIntegration ? [selectedIntegration] : undefined,
      contactSupplierId: selectedSupplier || null,
    }
    setIsCommitAllSubmitting(true)
    try {
      const preview = await thirdPartyConnectionImportLineService.commitAllImportLines({ ...request, confirm: false })
      const notReady = preview.requested - preview.ready
      const subsidiaryLabel = screenLabelsContext.getLabel('subsidiary', { plural: false })
      if (preview.ready === 0) {
        userNotificationsContext.openSnackbar({
          open: true,
          message: notReady > 0
            ? `None of the ${notReady} pending record${notReady === 1 ? ' is' : 's are'} ready to commit. Give each an activity, a group and a ${subsidiaryLabel} first.`
            : 'There is nothing to commit in this view.',
          backgroundColor: 'text.primary',
        })
        return
      }
      const reasons = [
        preview.skipped.noActivity ? `${preview.skipped.noActivity} without an activity` : null,
        preview.skipped.noSubsidiary + preview.skipped.noGroup
          ? `${preview.skipped.noSubsidiary + preview.skipped.noGroup} without a group or ${subsidiaryLabel}`
          : null,
        preview.skipped.duplicate ? `${preview.skipped.duplicate} flagged as possible duplicates` : null,
      ].filter(Boolean).join(', ')
      const confirmed = await userNotificationsContext.openDialog({
        active: true,
        title: 'Commit all?',
        message: notReady > 0
          ? `${preview.ready} of ${preview.requested} pending records in this view are ready and will be committed. ${notReady} will stay for review: ${reasons}.`
          : `${preview.ready} pending record${preview.ready === 1 ? '' : 's'} in this view will be committed.`,
        buttonCopy: 'Commit',
        cancelButtonCopy: 'Cancel',
      })
      if (!confirmed) return
      let committed = 0
      let remaining = preview.ready
      let failedBatch: ICommitAllImportLinesResult['failedBatch'] = null
      while (remaining > 0 && !failedBatch) {
        const result = await thirdPartyConnectionImportLineService.commitAllImportLines({ ...request, confirm: true })
        committed += result.committed
        failedBatch = result.failedBatch
        // No progress means nothing this call could reach: stop rather than loop.
        if (result.remaining >= remaining) break
        remaining = result.remaining
      }
      userNotificationsContext.openSnackbar({
        open: true,
        message: failedBatch
          ? `${committed} record${committed === 1 ? '' : 's'} committed before a batch failed: ${failedBatch.message}`
          : `${committed} record${committed === 1 ? '' : 's'} committed.`,
        backgroundColor: failedBatch ? 'text.primary' : undefined,
      })
      if (inputPage !== 0) {
        setInputPage(0)
      } else {
        getAllThirdPartyConnectionImportLines('outstanding')
      }
    } catch (err: any) {
      if (err?.response?.data?.code === 1) {
        userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
      } else {
        userNotificationsContext.openSnackbar({ open: true, message: err?.response?.data?.message || 'There was an error, please try again', backgroundColor: 'text.primary' });
      }
      console.log(err)
    } finally {
      setIsCommitAllSubmitting(false)
    }
  }

  const closeSpendBasedDialogHandler = () => {
    setDialogSpendBasedOpen(false)
    setEditUploadSpendBasedLine(undefined)
  }


  const deleteSpendBasedHandler = (uploadLineId: string, status?: string) => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
    } else {
      userNotificationsContext.openDialog({ active: true, title: 'Confirmation', message: `Are you sure you want to discard this record? This action cannot be undone.`, buttonCopy: 'Continue', cancelButtonCopy: 'Cancel' })
        .then(response => {
          if (response) {
            fileUploadAllLineService.deleteUploadLine(uploadLineId, 'spend-based')
              .then(response => {
                userNotificationsContext.openSnackbar({ open: true, message: 'Discarded successfully' });
                if (status === 'pending') {
                  if (inputPage > 0 && fileUpload && fileUpload.length === 1) {
                    setInputPage(inputPage - 1)
                  } else {
                    getUploads()
                  }
                  setSelectedPending([])
                  setPendingUploadLines([])
                }
                if (status === 'validated') {
                  if (inputPageMatched > 0 && fileUploadMatched && fileUploadMatched.length === 1) {
                    setInputPageMatched(inputPageMatched - 1)
                  } else {
                    getUploads()
                  }
                  setSelected([])
                  setValidatedUploadLines([])
                }
              })
              .catch(err => {
                if (err.response.data.code === 1) {
                  userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
                } else {
                  userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                }
                console.log(err)
              })
          }
        })
    }
  }

  const deleteRecordsHandler = (fromPending: boolean = false) => {
    if (isReportPeriodLocked) {
      userNotificationsContext.openDialog({ active: true, title: 'Action Not Allowed', message: `The selected report period is locked and cannot be modified`, buttonCopy: 'Ok', hideCancelButton: true })
    } else {
      userNotificationsContext.openDialog({ active: true, title: 'Confirmation', message: `Are you sure you want to discard this record(s)? This action cannot be undone.`, buttonCopy: 'Continue', cancelButtonCopy: 'Cancel' })
        .then(response => {
          const linesToDelete = fromPending ? pendingUploadLines : validatedUploadLines
          if (response && linesToDelete) {
            if (!isDiscardSubmitting) {
              setIsDiscardSubmitting(true)
              fileUploadAllLineService.deleteUploadLines(linesToDelete, 'spend-based')
                .then(response => {
                  if (fromPending) {
                    if (inputPage > 0 && fileUpload && fileUpload.length === 1) {
                      setInputPage(inputPage - 1)
                    } else {
                      getUploads()
                    }
                    setSelectedPending([])
                    setPendingUploadLines([])
                  } else {
                    if (inputPageMatched > 0 && fileUploadMatched && validatedUploadLines && (fileUploadMatched.length === 1 || validatedUploadLines.length === fileUploadMatched.length)) {
                      setInputPageMatched(inputPageMatched - 1)
                    } else {
                      getUploads()
                    }
                    setSelected([])
                    setValidatedUploadLines([])
                  }
                  userNotificationsContext.openSnackbar({ open: true, message: 'Discarded successfully' });
                  setIsDiscardSubmitting(false)
                })
                .catch(err => {
                  if (err.response.data.code === 1) {
                    userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
                  } else {
                    userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                  }
                  setIsDiscardSubmitting(false)
                  console.log(err)
                })
            }
          }
        })
    }
  }

  const successManualSpendBasedHandler = () => {
    setManualSpendBasedDialogOpen(false)
    setValue(2)
    setIsLoading(true)
  }

  const hasNominalCodes = (outstandingImportLines || []).some(line => line.nominalCode || line.hasMixedAccountCodes)

  // Mid-review mapping happens on the Chart of Accounts page, scoped to this period's review lines.
  // Every mapping write re-applies to lines in review server side, so the review reflects the save
  // when the user comes back.
  const nominalMappingLink = `/settings/data-upload/chart-of-accounts?${new URLSearchParams({
    ...(reportPeriodContext.lastSelectedReportId ? { reportPeriodId: reportPeriodContext.lastSelectedReportId } : {}),
    return: 'review',
  }).toString()}`

  return (
    <PageOuterContainer>
      <Stack direction={isMobileMode ? 'column' : 'row'} justifyContent='space-between' alignItems={isMobileMode ? 'flex-start' : 'center'} sx={{ mb: 1, mt: 1 }}>
        <PageTitle title='Spend Based Emissions' />
        {!isReportPeriodLocked &&
          <Stack direction={'row'} >
            {allContactSuppliers && allContactSuppliers.length > 0 && <Button variant='text' sx={{ mr: 1 }} onClick={() => setManualSpendBasedDialogOpen(true)}>
              <Add />
              <Typography>Add Emission</Typography>
            </Button>}
            {activeConnections && activeConnections.length === 0 &&
              <Button component={Link} to='/settings/integrations'>
                <Add />
                <Typography>Set up Integrations</Typography>
              </Button>
            }
            {activeConnections && activeConnections.length > 0 && !hasConnectedLedger && userDetails?.roles.includes('admin') && value === 0 &&
              <>
                <Button
                  variant='text'
                  id='set-up-connection-button'
                  aria-controls={setUpAnchorEl ? 'set-up-connection-menu' : undefined}
                  aria-haspopup='true'
                  onClick={(event) => setSetUpAnchorEl(event.currentTarget)}>
                  <Add />
                  <Typography>Set up accounting connection</Typography>
                </Button>
                <Menu
                  id='set-up-connection-menu'
                  anchorEl={setUpAnchorEl}
                  open={Boolean(setUpAnchorEl)}
                  onClose={() => setSetUpAnchorEl(null)}
                  MenuListProps={{ 'aria-labelledby': 'set-up-connection-button' }}
                >
                  {availableConnections.map(connection => (
                    <MenuItem key={connection.id} component={Link} to={`/settings/integrations/${connection.code}`}>{connection.name}</MenuItem>
                  ))}
                </Menu>
              </>
            }
            {activeConnections && activeConnections.length > 0 && (hasConnectedLedger || value !== 0) && userDetails?.roles.includes('admin') &&
              <Box sx={{ position: 'relative' }}>
                {value === 0 && <LoadingButton
                  loading={isSyncing}
                  loadingPosition="start"
                  startIcon={<Sync />}
                  variant="text"
                  id="basic-button"
                  aria-controls={openDropdown ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropdown ? 'true' : undefined}
                  onClick={clickDropdownHandler}>
                  <Typography>{isSyncing ? 'Syncing Data' : 'Sync Data'}</Typography>
                </LoadingButton>}
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropdown}
                  onClose={closeDropdownHandler}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  {connectedConnections.map(connection => (
                    <MenuItem key={connection.id} disabled={isSyncing} onClick={() => { connectionHandler(connection.code, connection.name) }}>{connection.name}</MenuItem>
                  ))}
                </Menu>
                {value === 0 && schedules && <Button
                  variant='text'
                  startIcon={<ScheduleOutlined />}
                  id='schedule-sync-button'
                  aria-controls={scheduleAnchorEl ? 'schedule-sync-menu' : undefined}
                  aria-haspopup='true'
                  onClick={clickScheduleHandler}>
                  <Typography>{hasScheduledSync ? 'Manage schedule' : 'Schedule sync'}</Typography>
                </Button>}
                <Menu
                  id='schedule-sync-menu'
                  anchorEl={scheduleAnchorEl}
                  open={Boolean(scheduleAnchorEl)}
                  onClose={() => setScheduleAnchorEl(null)}
                  MenuListProps={{ 'aria-labelledby': 'schedule-sync-button' }}
                >
                  {connectedConnections.map(connection => (
                    <MenuItem key={connection.id} onClick={() => { setScheduleAnchorEl(null); setScheduleProvider(connection) }}>{connection.name}</MenuItem>
                  ))}
                </Menu>
                {value === 1 && <Button variant='text' component={Link} to='/settings/data-upload/import-data'>
                  <UploadOutlined />
                  <Typography sx={{ display: 'inline' }}>Upload data</Typography>
                </Button>}
              </Box>}
          </Stack>}
      </Stack>
      {companies && connectionCode && connectionName && openDialog && !isReportPeriodLocked &&
        <SelectTenantDialog
          open={openDialog}
          isSubmitting={isDialogSubmitting}
          closeDialogHandler={closeDialogHandler}
          submitHandler={submitDialogHandler}
          dialogDetails={companies}
          connectionCode={connectionCode}
          connectionName={connectionName}
          periodStartDate={selectedReportPeriod?.startDate}
          periodEndDate={selectedReportPeriod?.endDate}
        />}
      {scheduleProvider &&
        <ScheduleSyncDialog
          open={!!scheduleProvider}
          onClose={closeScheduleDialogHandler}
          provider={scheduleProvider.code as AccountingSyncProvider}
          providerName={scheduleProvider.name}
        />}
      {hasOpenReport !== undefined && hasOpenReport === false &&
        <>
          <ClosedReportPeriodMessage openDialog={() => { setOpenReportPeriodDialogOpen(true) }} />
          {openReportPeriodDialogOpen && <StartNewReportPeriodDialog open={openReportPeriodDialogOpen} closeHandler={() => { setOpenReportPeriodDialogOpen(false) }} />}
        </>
      }
      {hasOpenReport &&
        <>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'lightGrey.main' }}>
              <Tabs value={value} onChange={changeTabHandler}>
                <Tab label='Pending via Integrations'  {...a11yProps(0)} />
                <Tab label='Pending via Import'  {...a11yProps(1)} />
                <Tab label='Committed' {...a11yProps(2)} />
                <Tab label='Discarded' {...a11yProps(3)} />
              </Tabs>
            </Box>
          </Box>
          <CustomTabPanel value={value} index={0}>
            {lastSyncCoverage && (
              <Alert
                severity={lastSyncCoverage.truncated ? 'warning' : 'info'}
                onClose={() => setLastSyncCoverage(null)}
                sx={{ mb: 2, mt: 2 }}
              >
                {buildCoverageMessage(lastSyncCoverage)}
              </Alert>
            )}
            {hasNominalCodes && !isReportPeriodLocked &&
              <Stack direction='row' justifyContent='flex-end' sx={{ mb: 2 }}>
                <Button
                  variant='outlined'
                  component={Link}
                  to={nominalMappingLink}
                  startIcon={<AccountTreeOutlined fontSize='small' />}>
                  <Typography sx={{ pl: 0.5 }}>Map account codes</Typography>
                </Button>
              </Stack>}
            {outstandingImportLines && subsidiaries && allContactSuppliers && allSpendBasedConversions && groups &&
              <EmissionsFinancialOutstandingTable
                outstandingImportLines={outstandingImportLines}
                setOutstandingImportLines={setOutstandingImportLines}
                setIsCommitSubmitting={setIsCommitSubmitting}
                allContactSuppliers={allContactSuppliers}
                spendBasedConversions={allSpendBasedConversions}
                isPendingIntegrationsLoading={isLoading}
                inputPage={inputPage}
                setInputPage={setInputPage}
                totalRecords={totalRecords}
                perPage={perPage}
                isCommitSubmitting={isCommitSubmitting}
                setPerPage={setPerPage}
                getAllThirdPartyConnectionImportLines={getAllThirdPartyConnectionImportLines}
                selectedSupplier={selectedSupplier}
                setSelectedSupplier={setSelectedSupplier}
                subsidiaries={subsidiaries}
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                groups={groups}
                resultYears={resultYears}
                integrationOptions={integrationOptions}
                selectedIntegration={selectedIntegration}
                setSelectedIntegration={setSelectedIntegration}
                onCommitAll={commitAllIntegrationLinesHandler}
                isCommitAllSubmitting={isCommitAllSubmitting}
              />}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <LoadingPage pageReady={!isLoading}>
              <Stack sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 4 }}>
                <Typography variant='h5' sx={{ color: 'primary.main', mb: 2 }}>Pending Upload Lines</Typography>
                {!isReportPeriodLocked &&
                  <Stack sx={{ display: 'flex', flexDirection: isMobileMode ? 'column' : 'row' }}>
                    <LoadingButton
                      onClick={() => deleteRecordsHandler(true)}
                      disabled={totalRecords === 0 || pendingUploadLines?.length === 0 || isAnyActionInProgress}
                      startIcon={<HighlightOff />}
                      variant='outlined'
                      loading={isDiscardSubmitting}
                      loadingPosition="start"
                      sx={{ mr: isMobileMode ? 0 : 2, mb: isMobileMode ? 2 : 0 }}>
                      <Typography>{isDiscardSubmitting ? 'Discarding Selected' : 'Discard Selected'}</Typography>
                    </LoadingButton>
                  </Stack>}
              </Stack>
              {fileUpload &&
                <CsvUploadSpendBased
                  deleteHandler={deleteSpendBasedHandler}
                  fileUploadLineSpendBaseds={fileUpload}
                  editClickHandler={editSpendBasedClickHandler}
                  openDialog={openSpendBasedDialog}
                  setValidatedUploadLines={setPendingUploadLines}
                  selected={selectedPending}
                  setSelected={setSelectedPending}
                  editUploadLine={editUploadSpendBasedLine}
                  closeDialogHandler={closeDialogHandler}
                  submitHandler={submitSpendBasedHandler}
                  inputPage={inputPage}
                  setInputPage={setInputPage}
                  totalRecords={totalRecords}
                  perPage={perPage}
                  setOrder={setOrder}
                  isSubmitting={isDialogSubmitting}
                  setOrderBy={setOrderBy}
                  setPerPage={setPerPage}
                  status={'pending'}
                />}
              <Stack sx={{ display: 'flex', flexDirection: isMobileMode ? 'column' : 'row', justifyContent: 'space-between', mb: 2, mt: 4 }}>
                <Typography variant='h5' sx={{ color: 'primary.main' }}>Matched Upload Lines</Typography>
                {!isReportPeriodLocked &&
                  <Stack sx={{ display: 'flex', flexDirection: isMobileMode ? 'column' : 'row', }}>
                    <LoadingButton
                      onClick={() => deleteRecordsHandler(false)}
                      disabled={validatedUploadLines?.length === 0 || isAnyActionInProgress}
                      startIcon={<HighlightOff />}
                      variant='outlined'
                      loading={isDiscardSubmitting}
                      loadingPosition="start"
                      sx={{ mr: isMobileMode ? 0 : 2, mb: isMobileMode ? 2 : 0 }}>
                      <Typography>{isDiscardSubmitting ? 'Discarding Selected' : 'Discard Selected'}</Typography>
                    </LoadingButton>
                    <LoadingButton
                      onClick={saveHandler}
                      disabled={validatedUploadLines?.length === 0 || isAnyActionInProgress}
                      startIcon={<SaveOutlined />}
                      variant='contained'
                      loading={isCommitSubmitting}
                      sx={{ mr: isMobileMode ? 0 : 2, mb: isMobileMode ? 2 : 0 }}
                      loadingPosition="start">
                      <Typography>{isCommitSubmitting ? 'Committing Selected' : 'Commit Selected'}</Typography>
                    </LoadingButton>
                    <LoadingButton
                      onClick={saveAllHandler}
                      disabled={totalRecordsMatched === 0 || isAnyActionInProgress}
                      startIcon={<SaveOutlined />}
                      variant='contained'
                      loading={isCommitAllSubmitting}
                      loadingPosition="start">
                      <Typography>{isCommitAllSubmitting ? 'Committing All' : 'Commit All'}</Typography>
                    </LoadingButton>
                  </Stack>}
              </Stack>
              {fileUploadMatched &&
                <CsvUploadSpendBased
                  fileUploadLineSpendBaseds={fileUploadMatched}
                  deleteHandler={deleteSpendBasedHandler}
                  editClickHandler={editSpendBasedClickHandler}
                  openDialog={openSpendBasedDialog}
                  setValidatedUploadLines={setValidatedUploadLines}
                  selected={selected}
                  isSubmitting={isDialogSubmitting}
                  setSelected={setSelected}
                  editUploadLine={editUploadSpendBasedLine}
                  closeDialogHandler={closeSpendBasedDialogHandler}
                  submitHandler={submitSpendBasedHandler}
                  inputPage={inputPageMatched}
                  setInputPage={setInputPageMatched}
                  totalRecords={totalRecordsMatched}
                  perPage={perPageMatched}
                  setPerPage={setPerPageMatched}
                  setOrder={setOrderMatched}
                  setOrderBy={setOrderByMatched}
                  status={'validated'}
                />}
            </LoadingPage>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            {/* <Box mb={2}> */}
            {/* <Box sx={{ mb: 1, display: 'flex', justifyContent: 'flex-start' }}>
                <CustomFilter
                  filters={filterConfig}
                  onFilterChange={handleFilterChange}
                  buttonAlignment="left"
                />
              </Box> */}

            {/* </Box> */}
            <LoadingPage pageReady={!isLoading}>
              <Emissions
                includeDelete={true}
                includeEdit={true}
                queryString="&spendOnly=true"
                backLink="/emissions/financial?tabId=2"
                backText="Back to financial emissions"
              />
            </LoadingPage>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <LoadingPage pageReady={!isLoading}>
              {discardedImportLines && subsidiaries && allContactSuppliers &&
                <EmissionsFinancialDiscardedTable
                  setOrder={setOrder}
                  allContactSuppliers={allContactSuppliers}
                  selectedSupplier={selectedSupplier}
                  setSelectedSupplier={setSelectedSupplier}
                  setOrderBy={setOrderBy}
                  discardedImportLines={discardedImportLines}
                  inputPage={inputPage}
                  setInputPage={setInputPage}
                  subsidiaries={subsidiaries}
                  totalRecords={totalRecords}
                  perPage={perPage}
                  setPerPage={setPerPage} />}
            </LoadingPage>
          </CustomTabPanel>
        </>}
      {openManualSpendBasedDialog && !isReportPeriodLocked &&
        <AddManualSpendBasedDialog
          open={openManualSpendBasedDialog}
          closeHandler={() => setManualSpendBasedDialogOpen(false)}
          successHandler={successManualSpendBasedHandler}
        />
      }
      {/* {openBulkEditDialog && reportPeriodContext.lastSelectedReportId && (
        <EditBulkUploadLinesDialog
          open={openBulkEditDialog}
          closeHandler={closeBulkEditDialogHandler}
          dialogDetailsIds={isEditAll ? [] : selected}
          successHandler={successBulkEditDialogHandler}
          showMenuItems={showMenuItems}
          reportPeriodId={reportPeriodContext.lastSelectedReportId}
          isForCommittedSpendBased={true}
          isEditAll={isEditAll}
          totalRecords={totalRecords}
          filters={completedFilters}
        />
      )} */}
    </PageOuterContainer>
  )
}